import React from "react";
import PropTypes from "prop-types";

const Toggle = ({
  id,
  checked,
  onChange,
  disabled,
  i18nItemLabel,
  ...sliderAttrs
}) => (
  <span className='modernized-toggle-web-sdk'>
    <input
      type='checkbox'
      id={id}
      className='toggle-checkbox-web-sdk'
      data-testid={`checkbox-${id}`}
      onChange={onChange}
      disabled={disabled}
      checked={checked}
    />
    <button
      type='button'
      className='toggle-slider-web-sdk'
      role='switch'
      aria-checked={checked}
      aria-label={i18nItemLabel}
      disabled={disabled}
      onClick={onChange}
      onKeyDown={event => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onChange();
        }
      }}
      data-testid={`toggle-${id}`}
      {...sliderAttrs}
    />
  </span>
);

const Label = ({ id, labelText, helpNode, children }) => (
  <div className='modernized-toggle-container-web-sdk'>
    <label
      id={`toggle-label-${id}`}
      data-testid={`toggle-label-${id}`}
      className='toggle-label-container-web-sdk'
      htmlFor={id}
    >
      <span
        className='toggle-label-text-web-sdk'
        data-testid={`toggle-label-text-${id}`}
      >
        {labelText}
      </span>
      {helpNode && (
        <span
          className='toggle-help-text-web-sdk'
          data-testid={`toggle-help-text-${id}`}
          aria-hidden='true'
        >
          {helpNode}
        </span>
      )}
    </label>
    {children}
  </div>
);

const ModernizedToggle = ({
  field: {
    defaultChecked,
    disabled,
    helpNode,
    i18nItemLabel,
    label,
    name,
    onChange
  }
}) => {
  /* eslint-disable jsx-a11y/label-has-associated-control */
  return label ? (
    <Label id={name} labelText={label} helpNode={helpNode}>
      <Toggle
        id={name}
        checked={defaultChecked}
        disabled={disabled}
        onChange={onChange}
        i18nItemLabel={i18nItemLabel}
        aria-labelledby={`toggle-label-${name}`}
      />
    </Label>
  ) : (
    <Toggle
      id={name}
      checked={defaultChecked}
      disabled={disabled}
      onChange={onChange}
      i18nItemLabel={i18nItemLabel}
    />
  );
};

Toggle.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  i18nItemLabel: PropTypes.string.isRequired
};

Label.propTypes = {
  id: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  helpNode: PropTypes.string,
  children: PropTypes.node
};

ModernizedToggle.propTypes = {
  field: PropTypes.shape({
    defaultChecked: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    helpNode: PropTypes.string,
    i18nItemLabel: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
  })
};

export default ModernizedToggle;
